'use client';

import { useRouter as useIntlRouter } from '@/navigation';
import { useRouter as useBPAppRouter } from '@bprogress/next/app';

export function useRouter() {
  const intlRouter = useIntlRouter();

  const bpRouter = useBPAppRouter({
    customRouter: () => intlRouter,
    i18nPath: true,
  });

  return bpRouter ?? intlRouter;
}
